import type { Sticker } from '../types';

export const shopping: Sticker[] = [
  {
    id: 9001,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/001-store.png',
    name: 'Sklep',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9002,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/002-basket.png',
    name: 'Koszyk',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9003,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/003-invoice.png',
    name: 'Faktura',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9004,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/004-discount.png',
    name: 'Rabat',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9005,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/005-cart.png',
    name: 'Wózek',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9006,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/006-check.png',
    name: 'Paragon',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9007,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/007-pay.png',
    name: 'Płatność',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9008,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/008-discount.png',
    name: 'Promocja',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9009,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/009-box.png',
    name: 'Paczka',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9010,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/010-delivery man.png',
    name: 'Kurier',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9011,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/011-barcode scanner.png',
    name: 'Skaner',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9012,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/012-mall.png',
    name: 'Centrum handlowe',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9013,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/013-wallet.png',
    name: 'Portfel',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9014,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/014-eshop.png',
    name: 'Sklep internetowy',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9015,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/015-discount.png',
    name: 'Zniżka',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9016,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/016-voucher.png',
    name: 'Voucher',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9017,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/017-cart.png',
    name: 'Koszyk zakupowy',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9018,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/018-cart.png',
    name: 'Wózek sklepowy',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9019,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/019-shopping.png',
    name: 'Zakupy',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 9020,
    url: 'https://stickers.nauczniaczek.pl/colections/13335117-shopping/png/020-shopping.png',
    name: 'Torba na zakupy',
    category: 'shopping',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];